import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Link } from "react-router-dom";
import { grantAnalytics } from "@/lib/analytics";

// Barra fina no rodapé da tela (full width, ≤64px no desktop) — não cobre
// botões nem o formulário.
export const CookieNotice = ({ onVisibilityChange }) => {
  const [show, setShow] = useState(() => {
    try {
      return !localStorage.getItem("melo-lgpd-ok");
    } catch (e) {
      return true;
    }
  });

  useEffect(() => {
    onVisibilityChange && onVisibilityChange(show);
  }, [show, onVisibilityChange]);

  const accept = () => {
    try {
      localStorage.setItem("melo-lgpd-ok", "1");
    } catch (e) {}
    grantAnalytics();
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="cookie-notice"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 30 }}
          className="fixed inset-x-0 bottom-[calc(64px+env(safe-area-inset-bottom))] z-50 border-t border-[#E5E0D5] bg-white/95 backdrop-blur-md sm:bottom-0"
        >
          <div className="mx-auto flex max-w-[1400px] items-center gap-3 px-4 py-2 sm:px-8">
            <p data-testid="cookie-text" className="min-w-0 flex-1 text-xs leading-snug text-[#2C332A]">
              Usamos cookies para melhorar sua experiência e medir, de forma anônima, o funcionamento do site. Ao continuar, você concorda com a{" "}
              <Link to="/politica-de-privacidade" data-testid="cookie-privacy-link" className="font-semibold text-[#233D25] underline underline-offset-2">Política de Privacidade</Link>.
            </p>
            <button
              data-testid="cookie-accept"
              onClick={accept}
              className="shrink-0 rounded-full bg-[#233D25] px-5 py-2 text-xs font-semibold text-[#F9F8F3] transition-colors duration-300 hover:bg-[#3E5B3F]"
            >
              Entendi
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
